webpackJsonp([12604861838853],{

/***/ 493:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mono2Ski","author":"Lawrence Gosset"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/ski-areas/la-banane/index.md absPath of file >>> MarkdownRemark","html":"<p>One of the most popular off-piste runs in the Bellevarde area is La Banane, due to it’s easy accessibility and large vertical descent (almost 900m in total).</p>\n<p>La Banane is suitable for intermediate to expert skiers, and is only safe dependant on conditions. Due to it’s length, it can potentially be very dangerous in variable conditions.</p>","frontmatter":{"title":"Le Banane","date":"2015-05-28T22:40:32.169Z","caption":"La Banane from a distance","difficulty":3,"image":{"childImageSharp":{"responsiveSizes":{"src":"/static/labanane-db840b7a52841f52115cf3594664d53b-71264.jpg"}}}}}},"pathContext":{"path":"/la-banane/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---la-banane-dddc4a09aa153071bf49.js